/**
 * Stammdaten des Betriebs.
 *
 * An einer Stelle gepflegt, damit Name, Slogan und Kontakt in Anmeldung,
 * Einstellungen, Seitentitel und App-Manifest nicht auseinanderlaufen.
 * Quelle: as-salem.de
 */
export const BETRIEB = {
    /** Vollständiger Name inklusive Inhaber, wie auf der Webseite geführt. */
    name: 'Malerbetrieb Adelbert Schmid',
    inhaber: 'Inh. Pierre Moll',
    /** Kurzform für enge Stellen wie den Startbildschirm des Handys. */
    kurzname: 'AS Salem',
    slogan: 'Traditionelles Handwerk, modern umgesetzt',
    ort: 'Salem',
    telefon: '+49 7553 570',
    /** Für `tel:`-Verweise, ohne Leerzeichen. */
    telefonRoh: '+497553570',
    webseite: 'https://as-salem.de',
};
/** Farben der Bildmarke. */
export const MARKENFARBEN = {
    dunkelblau: '#1d1b54',
    bernstein: '#fab51d',
};
//# sourceMappingURL=betrieb.js.map